// frontend/src/components/LocalBodiesSection.jsx
import React from "react";

const LocalBodiesSection = ({ panchayats = [], municipalities = [] }) => {
  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Panchayats */}
        {panchayats.length > 0 && (
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-green-700 mb-4">
              Rural Local Bodies (Panchayats)
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {panchayats.map((p, i) => (
                <div
                  key={i}
                  className="bg-white shadow rounded-lg p-4 hover:shadow-lg transition"
                >
                  <h3 className="text-lg font-semibold text-gray-800">
                    {p.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    District: {p.district}
                  </p>
                  <p className="text-sm text-gray-500">Ward: {p.ward}</p>
                  <p className="text-sm text-blue-600">
                    Head: {p.headName || "N/A"}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Municipalities */}
        {municipalities.length > 0 && (
          <div>
            <h2 className="text-2xl font-bold text-blue-700 mb-4">
              Urban Local Bodies (Municipalities)
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {municipalities.map((m, i) => (
                <div
                  key={i}
                  className="bg-white shadow rounded-lg p-4 hover:shadow-lg transition"
                >
                  <h3 className="text-lg font-semibold text-gray-800">
                    {m.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    City: {m.city} | Zone: {m.zone}
                  </p>
                  <p className="text-sm text-gray-500">Ward: {m.ward}</p>
                  <p className="text-sm text-blue-600">
                    Mayor: {m.mayor || "N/A"}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LocalBodiesSection;
